import React from 'react'
import { useNavigate } from 'react-router-dom'
import AppActionMenu from '../../../../components/AppActionMenu'

export default function NoticeTable({
  records = [],
  loading = false,
  onDelete,
}) {
  const navigate = useNavigate()

  return (
    <div className="overflow-hidden rounded-2xl border border-outline-variant/25 bg-surface-container-lowest shadow-xs">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs text-on-surface">
          {/* ── Table Header ── */}
          <thead className="border-b border-outline-variant/25 bg-surface-container-low/80 text-[11px] font-black uppercase tracking-[0.1em] text-on-surface-variant select-none">
            <tr>
              <th className="px-5 py-3.5">
                <span>Notices</span>
              </th>
              <th className="w-20 px-5 py-3.5 text-right">
                <span>Action</span>
              </th>
            </tr>
          </thead>

          {/* ── Table Body ── */}
          <tbody className="divide-y divide-outline-variant/15 font-medium">
            {loading ? (
              <tr>
                <td colSpan={2} className="py-16 text-center text-xs text-on-surface-variant">
                  <div className="flex flex-col items-center justify-center gap-2">
                    <span className="material-symbols-outlined animate-spin text-2xl text-primary">
                      progress_activity
                    </span>
                    <span>Loading notices...</span>
                  </div>
                </td>
              </tr>
            ) : records.length === 0 ? (
              <tr>
                <td colSpan={2} className="py-16 text-center text-xs text-on-surface-variant">
                  <div className="flex flex-col items-center justify-center gap-2">
                    <span className="material-symbols-outlined text-4xl text-outline-variant">
                      notifications_off
                    </span>
                    <p className="font-bold text-on-surface">No Notices Found</p>
                    <p className="text-[11px]">Click &quot;Add New&quot; to publish your first notice.</p>
                  </div>
                </td>
              </tr>
            ) : (
              records.map((item) => (
                <tr
                  key={item.id}
                  className="group transition-colors hover:bg-surface-container-low/50"
                >
                  {/* Notice Content */}
                  <td className="px-5 py-4 align-top">
                    <p className="text-xs text-on-surface font-medium leading-relaxed">
                      {item.notice}
                    </p>
                  </td>

                  {/* Actions (Three-Dot AppActionMenu) */}
                  <td className="px-5 py-4 align-top text-right">
                    <AppActionMenu
                      triggerLabel=""
                      triggerIcon="more_vert"
                      showChevron={false}
                      triggerClassName="rounded-lg p-1.5 text-outline-variant transition-colors hover:bg-surface-container-low hover:text-primary bg-transparent cursor-pointer"
                      items={[
                        { key: 'edit', label: 'Edit', icon: 'edit' },
                        { key: 'delete', label: 'Delete', icon: 'delete', destructive: true },
                      ]}
                      onSelect={(actionKey) => {
                        if (actionKey === 'edit') navigate(`/cloud/notice/edit/${item.id}`)
                        if (actionKey === 'delete') onDelete?.(item.id)
                      }}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
}
